<lms-dynamic-form
  [action]="this.game ? 'games.edit' : 'games.create'"
  [options]="{ disableCard: true }"
  [questions]="questions"
  (submit)="submit($event)"
>
  <ng-content select="[form-actions-before]" form-actions-before></ng-content>
</lms-dynamic-form>
